module.exports = __webpack_public_path__ + "assets/img/logonew.f3e5e2d6.png";